import { useState, useEffect } from 'react';
const sanitizeBreakpoint = (breakpoint, type) => {
    if (typeof breakpoint === 'number') {
        if (type === 'max-width') {
            return `${breakpoint - 0.02}px`;
        }
        else {
            return `${breakpoint}px`;
        }
    }
    else {
        return breakpoint;
    }
};
const useMediaQuery = (breakpoint, type = 'max-width') => {
    const [matches, setMatches] = useState(false);
    useEffect(() => {
        if (breakpoint) {
            const sanitizedBreakpoint = sanitizeBreakpoint(breakpoint, type);
            const media = window.matchMedia(`(${type}: ${sanitizedBreakpoint})`);
            const mediaQueryList = window.matchMedia('(orientation: portrait)');
            if (media.matches !== matches) {
                setMatches(media.matches);
            }
            const listener = () => setMatches(media.matches);
            window.addEventListener('resize', listener);
            mediaQueryList.addEventListener('change', listener);
            return () => {
                window.removeEventListener('resize', listener);
                mediaQueryList.removeEventListener('change', listener);
            };
        }
    }, [matches, breakpoint, type]);
    return matches;
};
export default useMediaQuery;
